module.exports = __webpack_public_path__ + "static/media/icon-pets-full-disabled.a56b0e6f.png";